import { Search, Filter ,ChevronDown} from "lucide-react";
import { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import  SelectOrder  from "./SelectOrder";
import DeliveryFulfillmentFlow from "./DeliveryFulfillmentFlow";
import { X,PackageX } from "lucide-react";
import { decryptData } from "../../../utils/storageCrypto";
import SupplierRating from "./SupplierRating";
export default function DeliveryManager() {
const navigate = useNavigate();
const [openFulfillment, setOpenFulfillment] = useState(false);
const [shipmentdata,setShipmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showCustomersPopup, setShowCustomersPopup] = useState(false);
const [showSuppliersPopup, setShowSuppliersPopup] = useState(false);
const [popupData, setPopupData] = useState([]);
const [showPickoffPopup, setShowPickoffPopup] = useState(false);
const [showDropoffPopup, setShowDropoffPopup] = useState(false);
const [selectedPickoffData, setSelectedPickoffData] = useState([]);
const [selectedDropoffData, setSelectedDropoffData] = useState([]);
const [selectedStatuses, setSelectedStatuses] = useState(["pending","out for delivery"]);
const [showStatusDropdown, setShowStatusDropdown] = useState(false);
const [showRatingPopup, setShowRatingPopup] = useState(false);
const [selectedSupplierId, setSelectedSupplierId] = useState(null);
const [selectedQuotationId, setSelectedQuotationId] = useState(null);

const STATUS_OPTIONS = ["pending", "delivered", "out for delivery"];
const STATUS_COLORS = {
  "Pending": "text-red-700 bg-red-50",
  "Delivered": "text-green-700 bg-green-50",
 "Out For Delivery": "text-orange-700 bg-orange-50",
};


const openRatingPopup = (supplier) => {
  setSelectedSupplierId(supplier.vendor_id);

  // ✅ Extract quotation_id (take first or based on logic)
  const quotationId = supplier.vendor_responses?.[0]?.quotation_id || null;

  setSelectedQuotationId(quotationId);
  setShowRatingPopup(true);
};

const toggleStatus = (status) => {
  setSelectedStatuses((prev) =>
    prev.includes(status)
      ? prev.filter((s) => s !== status)
      : [...prev, status]
  );
};

const toggleSelectAll = () => {
  if (selectedStatuses.length === STATUS_OPTIONS.length) {
    setSelectedStatuses([]);
  } else {
    setSelectedStatuses(STATUS_OPTIONS);
  }
};

const clearAll = () => {
  setSelectedStatuses([]);
};

const fetchAllDeliveryShipments = async () => {
  setLoading(true);
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-shipment/get-all-delivery-shipments`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const resData = await response.json();
    const data= resData?.data || [];
    console.log("shipmentdata",data);
    setShipmentData(data);
  } catch (error) {
    console.error("Error fetching delivery shipments:", error);
    return [];
  } finally {
    setLoading(false);
  }
};

const fetchCustomerDetailsById = async (customerId) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-customer-by-customerId?customer_id=${customerId}`, // ✅ FIXED URL
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    // 🔍 Handle API errors
    if (!response.ok) {
      console.error("API failed with status:", response.status);
      return null;
    }

    const resData = await response.json();
    console.log("Customer details:", resData);

    return resData?.data || null; // ✅ safe return

  } catch (error) {
    console.error("Error fetching customer details:", error);
    return null;
  }
};


useEffect(() => {
   fetchAllDeliveryShipments();
  }, []);

  useEffect(() => {
  const handleOutside = (e) => {
    if (!e.target.closest(".status-dropdown")) {
      setShowStatusDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleOutside);
  return () => document.removeEventListener("mousedown", handleOutside);
}, []);


 

  // Function to handle view click
const handleViewClick = (shipmentId) => {
  setSelectedShipmentId(shipmentId);
  setOpenFulfillment(true);
};

const filteredShipments = shipmentdata.filter((s) => {
  const term = searchTerm.toLowerCase().trim();
  const status = s.status?.toLowerCase() || "";

  const extractNumber = (val = "") => val.replace(/\D/g, "");

  // 🔹 Detect status typed in search
  const isStatusSearch =
  term === "pending" || term === "delivered" || term === "out for delivery";  // Added "out for delivery"

  // 🔍 Search match
  const searchMatch =
    !term ||
    extractNumber(s.delivery_shipment_number || "").includes(extractNumber(term)) ||
    s.delivery_type?.toLowerCase().includes(term) ||
    s.delivery_mode?.toLowerCase().includes(term) ||
    s.paid_by?.toLowerCase().includes(term) ||
    (isStatusSearch && status === term); // ⭐ IMPORTANT

  // ✅ Status filter logic
 const statusMatch =
  selectedStatuses.length === 0 ||
  selectedStatuses.includes(status);

  // 🔥 If searching status, IGNORE dropdown filter
  if (isStatusSearch) {
    return status === term;
  }

  return searchMatch && statusMatch;
});




const openCustomersPopup = async (customers) => {
  if (!customers || customers.length === 0) {
    setPopupData([]);
    setShowCustomersPopup(true);
    return;
  }

  try {
    const customerDetailsList = await Promise.all(
      customers.map(async (c) => {
        const details = await fetchCustomerDetailsById(c.customer_id);
        return details ? {
          ...details,
          address: c.address  // ✅ Use shipmentdata.customers[].address
        } : null;
      })
    );
    
    

    setPopupData(customerDetailsList.filter(Boolean)); // remove nulls
    setShowCustomersPopup(true);
  } catch (err) {
    console.error("Error loading customers:", err);
    setPopupData([]);
    setShowCustomersPopup(true);
  }
};

const openSuppliersPopup = (suppliers) => {
  setPopupData(suppliers || []);
  setShowSuppliersPopup(true);
};

const openPickoffPopup = (pickups) => {
  setSelectedPickoffData(pickups || []);
  setShowPickoffPopup(true);
};

const openDropoffPopup = (dropoffs) => {
  setSelectedDropoffData(dropoffs || []);
  setShowDropoffPopup(true);
};

   return (
    <>
<div className="space-y-4 pb-32 min-h-screen overflow-y-auto max-h-[80vh] p-1">
    {/* ================= DELIVERY MANAGER ================= */}
    <div className="border rounded-lg shadow-sm overflow-hidden">

      {/* Header */}
      <div className="flex flex-wrap items-center gap-3 mb-2 p-4">
        <div className="relative flex-1 min-w-[240px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
  type="text"
  placeholder="Search shipments"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  className="w-full pl-10 pr-4 py-2 border rounded-md text-sm"
/>
        </div>

      <div className="relative status-dropdown">
  <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />

  <div
    onClick={() => setShowStatusDropdown(!showStatusDropdown)}
    className="pl-10 pr-8 py-2 border rounded-md text-sm cursor-pointer bg-white"
  >
    {selectedStatuses.length === 0
  ? "All Status"
  : `${selectedStatuses.length} Selected`}
         <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
      
  </div>

 {showStatusDropdown && (
  <div className="absolute mt-1 right-0 min-w-[220px] bg-white border rounded-md shadow-lg z-50 overflow-hidden">
    
    {/* --- HEADER SECTION --- */}
    <div className="flex items-center justify-between px-4 py-2 border-b bg-gray-50">
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={selectedStatuses.length === STATUS_OPTIONS.length && STATUS_OPTIONS.length > 0}
          onChange={toggleSelectAll}
          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <span className="text-sm font-semibold text-gray-700">All Status</span>
      </label>

      <button
        onClick={clearAll}
        className="text-xs text-red-600 hover:text-red-800 hover:underline font-medium transition-colors"
      >
        Clear
      </button>
    </div>

    {/* --- STATUS LIST --- */}
    <div className="p-1 max-h-[250px] overflow-y-auto">
      {STATUS_OPTIONS.map((status) => (
        <label
          key={status}
          className="flex items-center gap-3 px-3 py-2 hover:bg-blue-50 rounded-md cursor-pointer transition-colors group"
        >
          <input
            type="checkbox"
            checked={selectedStatuses.includes(status)}
            onChange={() => toggleStatus(status)}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-600 group-hover:text-blue-700 capitalize whitespace-nowrap">
            {status}
          </span>
        </label>
      ))}
    </div>
  </div>
)}
</div>

      </div>

<div >

  {/* 📦 No data state (all shipments empty) */}
  {!loading && shipmentdata.length === 0 && (
    <div className="flex flex-col items-center justify-center min-h-[120px] px-4 border border-dashed border-gray-300 rounded-md mx-6 mb-4">
      <PackageX className="w-6 h-6 text-gray-400 mb-2" />
      <p className="text-sm text-gray-500 text-center leading-relaxed">
        Delivery shipments not found
      </p>
    </div>
  )}

  {/* ✅ Table or No search results */}
<div className="relative max-h-[30vh] overflow-y-auto overflow-x-auto">
  {/* 🔴 Loading state */}
  {loading && (
          <div className="text-center py-12 text-gray-500">Loading...</div>
  )}

  {/* ✅ Table / No Result */}
  {!loading && shipmentdata.length > 0 && (
    <table className="min-w-full table-fixed divide-y divide-gray-200">
     <thead className="border-gray-200 sticky top-0 z-20 bg-[#fafafc] text-[#6c7184] text-xs uppercase">
         <tr>
        <th className="px-4 py-3 text-center"> Shipment NO</th>
          <th className="px-4 py-3 text-center">Delivery By</th>
          <th className="px-4 py-3 text-center">Delivery Through</th>
          <th className="px-4 py-3 text-center">Pickups</th>
          <th className="px-4 py-3 text-center">DropOffs</th>
          <th className="px-4 py-3 text-center">Suppliers</th>
          <th className="px-4 py-3 text-center">Customers</th>
          <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">Distance</th>
{/*           <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">ETA</th> */}
          <th className="px-4 py-3 text-center">Delivery Charge</th>
{/*           <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">Paid By</th> */}
          <th className="px-4 py-3 text-center">Status</th>
{/*           <th className="px-4 py-3 text-center">Action</th>
 */}        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200">
        {filteredShipments.length > 0 ? (
          filteredShipments.map((s) => (
            <tr key={s._id}>
              <td onClick={() => handleViewClick(s._id)} className="px-4 py-3 text-center text-sm font-medium text-blue-600 cursor-pointer hover:underline">{s.delivery_shipment_number || "--"}</td>
              <td className="px-4 py-3 text-center text-sm">{s.delivery_type || "--"}</td>
              <td className="px-4 py-3 text-center text-sm">{s.delivery_mode || "--"}</td>
              <td className="px-4 py-3 text-center text-sm cursor-pointer text-blue-600 hover:underline"
               onClick={() => openPickoffPopup(s.pickups)}>{s.pickups?.length || "--"}</td>
              <td className="px-4 py-3 text-center text-sm cursor-pointer text-blue-600 hover:underline"
             onClick={() => openDropoffPopup(s.dropoffs)}>{s.dropoffs?.length || "--"}</td>
             <td
  className="px-4 py-3 text-center text-sm text-blue-600 cursor-pointer underline"
  onClick={() => openSuppliersPopup(s.suppliers)}
>
  {s.suppliers?.length || 0}
</td>
             <td
  className="px-4 py-3 text-center text-sm text-blue-600 cursor-pointer underline"
  onClick={() => openCustomersPopup(s.customers)}
>
  {s.customers?.length || 0}
</td>
              <td className="px-4 py-3 text-center text-sm">{`${s.total_distance} km` || "--"}</td>
{/*               <td className="px-4 py-3 text-center text-sm">{s.eta || "--"}</td> */}
              <td className="px-4 py-3 text-center text-sm">{s.estimated_delivery_charge || "--"}</td>
{/*               <td className="px-4 py-3 text-center text-sm">{s.paid_by || "--"}</td> */}
                   <td className="px-4 py-3 text-center text-sm">
                     <span
                      className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                       STATUS_COLORS[s.status] || "text-gray-600 bg-gray-100"
                      }`}
                       >
                   {s.status || "--"}
                 </span>
                 </td>
{/*                 <td className="px-4 py-2 text-center">
                <span
                  onClick={() => handleViewClick(s._id)}
                  className="inline-block cursor-pointer rounded-md border border-blue-500 px-3 py-1 text-sm text-blue-500 hover:bg-blue-50"
                >
                  View
                </span>
              </td> */}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={12} className="text-center py-12">
              <div className="flex flex-col items-center justify-center">
                <Search className="w-6 h-6 text-gray-400 mb-2" />
                <p className="text-sm text-gray-500 text-center leading-relaxed">
                  No Result Found
                </p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )}
</div>

</div>


    </div>

    {/* ================= GAP + SALES ORDER / SELECT ORDER ================= */}
    <div className="pt-2 pb-8">
    <SelectOrder
  onOpenFulfillment={(shipmentId) => {
    setSelectedShipmentId(shipmentId);
    setOpenFulfillment(true);
  }}
  onShipmentCreated={fetchAllDeliveryShipments}
/>
    </div>
    </div>

   {openFulfillment && (
  <div
    className="fixed top-0 left-0 w-screen h-screen z-[9999] bg-black/60"
  >
    {/* Center wrapper */}
    <div className="w-full h-full flex items-center justify-center">

      {/* POPUP CONTAINER */}
      <div className="relative w-[80vw] max-w-[1400px] h-[calc(100vh-32px)] bg-white rounded-xl shadow-2xl overflow-hidden flex">

        {/* Close Button */}
        <button
          onClick={() => setOpenFulfillment(false)}
          className="absolute top-3 right-3 z-50 p-2 rounded-full bg-white hover:bg-gray-100"
        >
          <X size={18} />
        </button>

        {/* CONTENT */}
        <div className="flex-1 min-h-0 min-w-0 overflow-hidden pt-6">
          <DeliveryFulfillmentFlow
          shipmentId={selectedShipmentId}
          showAside={false} />
        </div>

      </div>
    </div>
  </div>
)}


{showCustomersPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-3xl max-h-[80vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => setShowCustomersPopup(false)}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-lg font-semibold mb-6 text-gray-900 flex-items-start">
        Customer Details
      </h3>

      {popupData.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <p className="text-lg font-medium">No customers found</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Name</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Mobile</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {popupData.map((c, i) => (
                <tr key={c._id || i} className="hover:bg-gray-50">
                  <td className="px-4 py-2 align-top">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900">
                       {c.customer_name} 
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-2 align-top text-gray-800">
                    {c.mobile_number} 
                  </td>
                  <td className="px-4 py-2 align-top">
                    <div className="px-3 py-2 text-xs text-blue-900">
                      {c.address || "--"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}



{showSuppliersPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-3xl max-h-[80vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => setShowSuppliersPopup(false)}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-lg font-semibold mb-6 text-gray-900 flex-items-start">
        Supplier Details
      </h3>

      {popupData.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <p className="text-lg font-medium">No suppliers found</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Name</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Company</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Mobile</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Address</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Rate</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {popupData.map((s, i) => (
                <tr key={s._id || i} className="hover:bg-gray-50">
                  <td className="px-4 py-2 align-top">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900">
                        {s.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-2 align-top text-gray-800 font-medium">
                    {s.company_name}
                  </td>
                  <td className="px-4 py-2 align-top text-gray-800">
                    {s.mobile_number}
                  </td>
                  <td className="px-4 py-2 align-top">
                    <div className=" px-3 py-2 text-xs text-blue-900 max-w-xs truncate">
                      {s.address || "--"}
                    </div>
                  </td>
                  <td className="px-4 py-2 align-top text-center">
                  <button
                    onClick={() => openRatingPopup(s)}
                    className="text-blue-600 hover:text-blue-800 text-sm font-medium underline"
                  >
                    {s.rating_exists ? "View / Edit" : "Rate"}
                  </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}

{showPickoffPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-[95vw] lg:max-w-6xl max-h-[95vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => {
          setShowPickoffPopup(false);
          setSelectedPickoffData([]);
        }}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-lg font-semibold mb-6 text-gray-900">Pickoff Details</h3>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg">
          <thead className="bg-gray-50 border-b border-gray-300">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Order ID
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Contact
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Phone
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Address
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Items
              </th>
            </tr>
          </thead>
          <tbody>
            {selectedPickoffData.length > 0 ? (
              selectedPickoffData.map((pickup, index) => (
                <tr key={pickup._id || index} className="hover:bg-gray-50">
                  {console.log("pickup data", pickup)}
                  <td className="border border-gray-300 px-4 py-2 text-sm font-bold text-gray-800">
                    {pickup.order_id || pickup.order_number || pickup.reference || `#${index + 1}`}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">
                    {pickup.contact?.name || pickup.contact_name || "--"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">
                    {pickup.contact?.phone || pickup.phone || "--"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">
                    <div className="max-w-xs truncate">{pickup.location?.address || pickup.address || "--"}</div>
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-900">
                    {Array.isArray(pickup.items)
                      ? pickup.items.length
                      : pickup.item_count ?? pickup.items ?? "--"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="border border-gray-300 px-4 py-8 text-center text-sm text-gray-500">
                  No pickup records available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}

{showDropoffPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-[95vw] lg:max-w-6xl max-h-[95vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => {
          setShowDropoffPopup(false);
          setSelectedDropoffData([]);
        }}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      {/* Header */}
      <h3 className="text-lg font-semibold mb-6 text-gray-900">Dropoff Details</h3>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg">
          <thead className="bg-gray-50 border-b border-gray-300">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Order ID
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Contact
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Phone
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Address
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Requested Items
              </th>
            </tr>
          </thead>
         <tbody>
            {selectedDropoffData.length > 0 ? (
              selectedDropoffData.map((dropoff, index) => (
                <tr key={dropoff._id || index} className="hover:bg-gray-50">
                  {console.log("dropoff data", dropoff)}
                  <td className="border border-gray-300 px-4 py-2 text-sm font-bold text-gray-800">
                    {dropoff.order_id || dropoff.order_number || dropoff.reference || `#${index + 1}`}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">
                    {dropoff.contact?.name || dropoff.contact_name || "--"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">
                    {dropoff.contact?.phone || dropoff.phone || "--"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">
                    <div className="max-w-xs truncate">{dropoff.location?.address || dropoff.address || "--"}</div>
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-900">
                    {Array.isArray(dropoff.items)
                      ? dropoff.items.length
                      : dropoff.requested_items ?? dropoff.quantity ?? dropoff.qty ?? "--"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} className="border border-gray-300 px-4 py-8 text-center text-sm text-gray-500">
                  No dropoff records available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}

{showRatingPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white flex flex-col items-center justify-center rounded-xl w-full max-w-[95vw] lg:max-w-3xl max-h-[90vh] overflow-auto p-6 shadow-2xl relative">
      
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow border"
        onClick={() => setShowRatingPopup(false)}
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-lg font-semibold mb-4 text-gray-900 text-center w-full">
        Supplier Rating
      </h3>

      {/* ✅ Rating Component */}
      {selectedSupplierId && (
        <div className="w-full flex justify-center">
          <SupplierRating supplierId={selectedSupplierId} quotationId={selectedQuotationId} />
        </div>
      )}
    </div>
  </div>
)}

  </>
);

}


